import { get, post, put, patch } from '../../networkClient';
import { Path } from '../path';

export function dupNewAccount(payload) {
  return post(Path.TENANT_CREATE, payload, undefined, undefined, true);
}

export function updatePortal(payload) {
  const { tenantId, ...rest } = payload;
  return patch(`/clients/${tenantId}`, rest, undefined, undefined, true, true);
}

export function getTenantDetailsApi(params) {
  return get(`${Path.CLIENTS}/${params}`, null, null, true, true);
}
export function verifyCommunityApi(payload) {
  return post(Path.VERIFY_COMMUNITY, payload, null, null, true);
}
export function ingestCommunityApi(payload) {
  return post(Path.INGEST_COMMUNITY, payload, null, null, true);
}

export function validatePmsApi(clientId, payload) {
  return post(
    `${Path.CLIENTS}/validate/${clientId}`,
    payload,
    undefined,
    undefined,
    true
  );
}

export function ingestedCommunitiesApiGet(payload) {
  return get(
    `${Path.INGESTED_COMMUNITIES}?tenantId=${payload}`,
    null,
    null,
    true,
    true
  );
}

export function createInternalSettingsApi(payload) {
  return post(Path.INTERNAL_SETTINGS, payload, undefined, undefined, true);
}
export function updateRestrictCommunicationApi(payload) {
  return patch(Path.RESTRICT_COMMUNICATION, payload, null, null, true, true);
}

export function verifyRentCafeApi(payload) {
  return post(Path.VERIFY_RENT_CAFE, payload, null, null, true);
}

export function getInternalSettingsApi(params) {
  return get(
    `${Path.INTERNAL_SETTINGS}${params ? `?clientId=${params}` : ''}`,
    undefined,
    undefined,
    true,
    true
  );
}

export function createCommunityConfigs(communityId) {
  return get(
    `${Path.CREATE_COMMUNITY_CONFIGS}?communityId=${communityId}`,
    null,
    null,
    true,
    true
  );
}

export function loadSourcesForVoiceAI(communityId) {
  return get(
    `${Path.LOAD_LEAD_SOURCES_FOR_VOICE_AI}/${communityId}`,
    null,
    null,
    true,
    true
  );
}

export function updateClientEmailSettingsApi(clientId, payload) {
  return patch(
    `${Path.CLIENTS}/${clientId}`,
    payload,
    undefined,
    undefined,
    true,
    true
  );
}
export function onboardCommunitiesApi(payload) {
  return post(`${Path.COMMUNITIES}/onboard`, payload, null, null, true, true);
}
export function getCommunitiesApi(clientId) {
  return get(
    `${Path.COMMUNITIES}?client_id=${clientId}`,
    null,
    null,
    true,
    true
  );
}
export function updateCommunityApi(payload) {
  return patch(Path.COMMUNITIES, payload, null, null, true, true);
}
export function configIntegrationApi(payload) {
  return put(Path.CONFIGURE_INTEGRATION, payload, null, null, true, true);
}
export function deletePhoneNumber(payload) {
  return put(Path.DELETE_PHONE_NUMBER, payload, null, null, true, true);
}

export function purchasePhoneNumberApi(payload) {
  return patch(Path.PURCHASE_PHONE_NUMBER, payload, null, null, true, true);
}

export function getAvailablePhoneNumberApi(id) {
  return get(`${Path.GET_PHONE_NUMBERS}/${id}`, null, null, true, true);
}

export function getClientsApi() {
  return get(Path.CLIENTS, null, null, true, true);
}

export function updateClientApi(clientId, data) {
  return patch(`${Path.CLIENTS}/${clientId}`, data, null, null, true, true);
}

export function getCommunityFeatureFlagsApi(communityId) {
  // Use useNewBaseUrl=true to hit REACT_APP_SERVER_URL_V2 which routes to rb-backend-apis
  // The base URL already includes /apis/v1, so just use /community-config/:communityId/feature-flags
  return get(
    `${Path.COMMUNITY_CONFIG}/${communityId}/feature-flags`,
    null,
    null,
    true,
    true
  );
}

export function updateCommunityFeatureFlagsApi(communityId, featureFlags) {
  // Use useNewBaseUrl=true to hit REACT_APP_SERVER_URL_V2 which routes to rb-backend-apis
  // The base URL already includes /apis/v1, so just use/community-config/:communityId/feature-flags
  return put(
    `${Path.COMMUNITY_CONFIG}/${communityId}/feature-flags`,
    {
      featureFlags
    },
    null,
    null,
    true,
    true
  );
}
